import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import Manifesto from "../components/sections/Manifesto";
import LeadSection from "../components/sections/LeadSection";
import { SERVICES, IMAGES } from "../lib/site";

export default function Services() {
  return (
    <main data-testid="services-page">
      <PageHero
        kicker="Our services"
        title="Every kind of solar, done properly."
        subtitle="From a single rooftop to a megawatt plant, Synergy Solar designs, installs and maintains complete solar systems across the Tricity and Himachal."
        image={IMAGES.comm2}
      />

      <section className="bg-cream py-24 md:py-32">
        <div className="mx-auto max-w-[1400px] space-y-6 px-6 md:px-12">
          {SERVICES.map((s, i) => (
            <Reveal key={s.slug} delay={0.05}>
              <div id={s.slug} data-testid={`service-${s.slug}`}
                className={`grid items-center gap-8 overflow-hidden rounded-[2rem] border border-line bg-white/50 md:grid-cols-2 md:gap-0 ${i % 2 === 1 ? "md:[&>div:first-child]:order-2" : ""}`}>
                <div className="p-8 md:p-12">
                  <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-forest text-cream"><s.icon className="h-6 w-6" /></span>
                  <p className="mt-5 font-mono text-xs uppercase tracking-widest text-gold">{s.tagline}</p>
                  <h2 className="mt-2 font-heading text-3xl font-extrabold tracking-tight text-forest md:text-4xl">{s.title}</h2>
                  <p className="mt-4 text-base leading-relaxed text-moss">{s.short}</p>
                  <ul className="mt-6 grid gap-3 sm:grid-cols-2">
                    {s.points.map((p) => (
                      <li key={p} className="flex items-start gap-2 text-sm text-ink">
                        <Check className="mt-0.5 h-4 w-4 shrink-0 text-gold" /> {p}
                      </li>
                    ))}
                  </ul>
                  <Link to="/contact" className="mt-8 inline-flex items-center gap-2 rounded-full bg-forest px-6 py-3 text-sm font-semibold text-cream transition-transform duration-300 hover:scale-95 hover:bg-forest-hover">
                    Get a quote <ArrowRight className="h-4 w-4" />
                  </Link>
                </div>
                <div className="relative h-64 md:h-full md:min-h-[380px]">
                  <img src={s.image} alt={s.title} className="h-full w-full object-cover" />
                  <div className="absolute inset-0 bg-forest/10 mix-blend-multiply" />
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <Manifesto />
      <LeadSection sourcePage="Services Page" title="Not sure which system fits? Let's find out." />
    </main>
  );
}
